import { render, staticRenderFns } from "./BeatModal.vue?vue&type=template&id=33b807f4&scoped=true"
import script from "./BeatModal.vue?vue&type=script&lang=ts"
export * from "./BeatModal.vue?vue&type=script&lang=ts"
import style0 from "./BeatModal.vue?vue&type=style&index=0&id=33b807f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b807f4",
  null
  
)

export default component.exports